import { RemiButton, type RemiButtonProps } from "@remi/next-ui";

type EmailButtonProps = RemiButtonProps & {
  email?: string;
};

export const EmailButton = ({ email, className, "aria-label": ariaLabel, ...props }: EmailButtonProps) => {
  const defaultAriaLabel = email ? `Email ${email}` : undefined;

  return (
    <a href={email ? `mailto:${email}` : undefined} className={className} aria-label={ariaLabel ?? defaultAriaLabel}>
      <RemiButton {...props} className={className} disabled={!email ? true : props.disabled} />
    </a>
  );
};
